import { Button, Callout, EditableText } from '@blueprintjs/core'
import * as classnames from 'classnames/bind'
import * as firebase from 'firebase'
import * as React from 'react'
import { connect } from 'react-redux'
import { dispatch, RootState, select, store } from '../../store'
import Avatar from '../Avatar'
import { CardContainer } from '../Card'
import styles from './account-card.scss'

const cx = classnames.bind(styles)

class AccountCard extends React.PureComponent {
  public state = {
    callout: null,
    error: null,
  }

  public handleEmailSave = (email: string) => {
    // TODO: should popup auth modal to re-authenticate
    const currentUser = firebase.auth().currentUser
    if (currentUser && currentUser.email) {
      const password = ''
      const credential = firebase.auth.EmailAuthProvider.credential(currentUser.email, password)
      currentUser.reauthenticateAndRetrieveDataWithCredential(credential).then(() => {
        currentUser.updateEmail(email)
          .then(_ => dispatch.auth.updateUser(currentUser))
          .catch(error => this.setState({ error }))
      })
    }
  }

  public handleResetPassword = (email: string) => {
    this.setState({ callout: null })
    firebase.auth().sendPasswordResetEmail(email)
      .then(_ => this.setState({ callout: <Callout intent="success">已寄送密碼重設信件至 {email}</Callout> }))
      .catch(error => this.setState({ callout: <Callout intent="danger">{error.message}</Callout> }))
  }

  public render() {
    const rootState = store.getState()
    const currentUser = firebase.auth().currentUser
    const user = currentUser ? select.users.getById(rootState, currentUser.uid) : null
    return (
      <CardContainer className={cx('profile-card')}>
        <Avatar className={cx('profile-card__avatar')} userId={currentUser ? currentUser.uid : undefined} />
        <div className={cx('profile-card__content')}>

          {/* email */}
          <div className={cx('profile-card__info-item')}>
            <div className={cx('profile-card__info-label')}>信箱</div>
            <div className={cx('profile-card__info-content')}>
              <h3 className={cx('name')}>{user ? <EditableText defaultValue={user.email} disabled={true} onConfirm={this.handleEmailSave} /> : 'N/A'}</h3>
            </div>
          </div>

          {/* password */}
          <div className={cx('profile-card__info-item')}>
            <div className={cx('profile-card__info-label')}>密碼</div>
            <div className={cx('profile-card__info-content')}>
              <h3 className={cx('para')}>
                {currentUser ? <Button onClick={this.handleResetPassword.bind(this, currentUser.email)}>重設密碼</Button> : null}
                {this.state.callout}
              </h3>
            </div>
          </div>
        </div>
      </CardContainer>
    )
  }
}

const mapState = ({ users }: RootState) => ({ users })
export default connect(mapState)(AccountCard)



// WEBPACK FOOTER //
// ./src/components/AccountCard/index.tsx